<template>
  <div id="app" class="container-fluid m-0 p-0">
    <Nav />
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>

    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
export default {
  components: { Footer, Nav },
};
</script>

<style>
#app {
  font-family: "Segoe UI", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: rgb(250, 250, 250);
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: "Cambria", serif;
}
</style>
